import Anchor from './anchor-link';

export { Anchor };
